import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Form, notification } from 'antd';
import ManageGarmentService from '../../../../services/ManageGarmentService';

const EditQty = ({ binId, getKanbanData, userData, editValue, handleArrowClick }) => {

  const [dataSource, setDataSource] = useState(editValue);
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  console.log(getKanbanData);

  useEffect(() => {
    setDataSource(editValue);
  }, [editValue]);

  const tableStyle = {
    backgroundColor: '#9F5375',
    color: '#ffffff',
    padding: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',
    margin: '0 auto',
  };

  const columns = [
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      width: 170,
      render: (text) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <span style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {text}
          </span>
        </div>
      ),
    },
    {
      title: 'Available Quantity',
      dataIndex: 'avilableQty',
      key: 'avilableQty',
      width: 160,
      render: (text) => (
        <div
          style={tableStyle}
        >
          {text}
        </div>
      ),
    }
  ];

  const handleSubmit = async () => {

    setLoading(true);
    try {
      const response = await ManageGarmentService.add_garment_to_Bin(getKanbanData, userData, binId );

      openNotificationWithIcon('success', response.message)

      setTimeout(() => {
        handleArrowClick();
        setLoading(false);
      }, 800);
    } catch (error) {
      console.error('Error submitting EOL dispatch:', error);
      openNotificationWithIcon('error', 'Failed to submit EOL dispatch. Please try again.');
      setLoading(false);
    }
  };


  const openNotificationWithIcon = (type, message) => {
    const messages = {
      error: {
        message: 'Error',
        description: message,
      },
      success: {
        message: 'Success',
        description: message,
      },
      warning: {
        message: 'Warning',
        description: message,
      },
    };

    api[type](messages[type]);
  };

  return (
    <div>
      {contextHolder}
      <Table
        size='small'
        style={{ width: '80%' }}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowClassName="editable-row"
        components={{
          header: {
            cell: (props) => (
              <th
                {...props}
                style={{
                  textAlign: "center",
                }}
              >
                {props.children}
              </th>
            ),
          },
        }}
        footer={() => (
          dataSource.length > 0 ? (
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop:'20px' }}>
              <Button
                type="primary"
                style={{ marginRight: '8px' }}
                onClick={handleSubmit}
                loading={loading}
              >
                Add Garment
              </Button>
              <Button onClick={handleArrowClick}>Cancel</Button>
            </div>
          ) : null
        )}
      />
    </div>
  );
};

export default EditQty;